import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CardModule } from 'primeng/card';
import { TooltipModule } from 'primeng/tooltip';
import { BadgeModule } from 'primeng/badge';
@Component({
  selector: 'gig-overview-box',
  templateUrl: './overview-box.component.html',
    styleUrls: ['./overview-box.component.scss'],
    standalone: true,
  imports: [CommonModule,CardModule,TranslateModule,TooltipModule,BadgeModule],
  providers: [CurrencyPipe, DecimalPipe]
})
export class OverviewBoxComponent implements OnInit, OnChanges {

  @Input() title: string;
  @Input() overviewText: string;
  @Input() badgeText: string;
  @Input() isPercentage: boolean = false;
  @Input() badgeClass: string;
  @Input() toolTipPath: string;
  @Input() showUpDwnImg: boolean = false;
  @Input() showBadge: boolean = false;
  @Input() type: string = 'text';


  constructor(
    private currencyPipe: CurrencyPipe,
    private decimalPipe: DecimalPipe) { }

  ngOnChanges(changes: SimpleChanges): void {
      let ovValue = changes.overviewText.currentValue;
      // if (ovValue === null || ovValue === undefined) {
      //   this.overviewText = '0';
      //   return;
      // }

      if (this.type === 'number') {
        this.overviewText = this.decimalPipe.transform(ovValue, '1.0-0');
      } else if (this.type === 'currency') {
        this.overviewText = this.currencyPipe.transform(ovValue, 'USD');
      }
  }
  ngOnInit(): void {

  }

}
